import { Injectable } from '@angular/core';

import { Tax } from '../../models/tax';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class TaxService {
  private url: string = 'taxes';

  constructor(private httpClient: HttpClientService) {}

  delete(id: number): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json`);
  }

  formOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { form_options: true });
  }

  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  save(tax: Tax): Promise<any> {
    if (tax.id) return this.httpClient.put(`${this.url}/${tax.id}.json`, { tax: tax });
    else return this.httpClient.post(`${this.url}.json`, { tax: tax });
  }

  show(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`);
  }
}
